/**
 * Checks if `value` exists (not null, not undefined). Throws if it doesn't.
 * @param what The ID of the error
 * @throws If `value` is null or undefined.
 */
export function assertExist<T>(
  value: T,
  what: string,
): asserts value is Exclude<Exclude<T, undefined>, null> {
  if (value === null || value === undefined) {
    throw new AssertExistError(what);
  }
}

class AssertExistError extends Error {
  value: string;

  constructor(value: string) {
    super('Expected value missing: ' + value);
    this.value = value;
  }
}
